import { Component, AfterViewInit } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css']
})
export class CookieConsentComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    CookieConsent.run({
      onFirstConsent: ({ cookie }) => {
      },

      onConsent: ({ cookie }) => {
      },

      onChange: ({ changedCategories, changedServices }) => {
      },

      onModalReady: ({ modalName }) => {
      },

      onModalShow: ({ modalName }) => {
      },

      onModalHide: ({ modalName }) => {
      },

      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        analytics: {
          autoClear: {
            cookies: [
              {
                name: /^_ga/, // regex: match all cookies starting with '_ga'
              },
              {
                name: '_gid', // string: exact cookie name
              },
            ],
          },

          services: {
            ga: {
              label: 'Google Analytics (dummy)',
              onAccept: () => {},
              onReject: () => {},
            },
            youtube: {
              label: 'Youtube Embed (dummy)',
              onAccept: () => {},
              onReject: () => {},
            },
          },
        },
        ads: {},
      },

      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: {
              title: 'Cookies Settings',
              description:
                'We use cookies and similar technologies to help personalize content, tailor and measure ads, and provide a better experience. By clicking accept, you agree to this, as outlined in our Cookie Policy.',
              acceptAllBtn: 'Accept all',

              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Preferences',
              // footer: `
              //       <a href="#path-to-impressum.html" target="_blank">Impressum</a>
              //       <a href="#path-to-privacy-policy.html" target="_blank">Privacy Policy</a>
              //   `,
            },
            preferencesModal: {
              title: 'Preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Accept current selection',
              closeIconLabel: 'Close modal',
              serviceCounterLabel: 'Service|Services',
              sections: [
                {
                  title: 'Your Privacy Choices',
                  description: `In this panel you can express some preferences related to the processing of your personal information. You may review and change expressed choices at any time by resurfacing this panel via the provided link. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
                },
                {
                  title: 'Strictly Necessary',
                  description:
                    'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Performance and Analytics',
                  description:
                    'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                  linkedCategory: 'analytics',
                  cookieTable: {
                    caption: 'Cookie table',
                    headers: {
                      name: 'Cookie',
                      domain: 'Domain',
                      desc: 'Description',
                    },
                    body: [
                      {
                        name: '_ga',
                        domain: window.location.hostname,
                        desc: 'Description 1',
                      },
                      {
                        name: '_gid',
                        domain: window.location.hostname,
                        desc: 'Description 2',
                      },
                    ],
                  },
                },
                {
                  title: 'Targeting and Advertising',
                  description:
                    'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
                  linkedCategory: 'ads',
                },
                {
                  title: 'More information',
                  description:
                    'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>',
                },
              ],
            },
          },
        },
      },
    });
  }
}